"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var BaseStorageService = /** @class */ (function () {
    function BaseStorageService() {
        var _this = this;
        this.initialize = function (storageKey) {
            _this.storage = _this.getJson(storageKey);
            _this.storageKey = storageKey;
        };
        this.flush = function () {
            window.clearTimeout(_this.flushAsyncId);
            _this.flushAsyncId = setTimeout(function () {
                _this.setJson(_this.storageKey, _this.storage);
            });
        };
        this.storage = {};
        this.storageKey = null;
        this.flushAsyncId = null;
    }
    BaseStorageService.prototype.get = function (path, defaultValue) {
        return _.get(this.storage, path, defaultValue);
    };
    BaseStorageService.prototype.set = function (path, value) {
        _.set(this.storage, path, value);
        this.flush();
    };
    BaseStorageService.prototype.getJson = function (key) {
        var value = localStorage.getItem(key);
        try {
            if (value) {
                return JSON.parse(value);
            }
        }
        catch (e) {
            //
        }
        return {};
    };
    BaseStorageService.prototype.setJson = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    return BaseStorageService;
}());
exports.default = BaseStorageService;
